/**
 * Combined placement string identical to Floating-UI's `Placement` union, kept
 * local so the public `Dropdown` API (`placement?: Placement`) stays byte-for-byte
 * compatible without importing the Floating-UI runtime package.
 */
export type Placement =
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'right'
  | 'right-start'
  | 'right-end'
  | 'left'
  | 'left-start'
  | 'left-end';

/**
 * Radix `DropdownMenuContent` positions via discrete `side` + `align` props,
 * whereas the legacy Floating-UI `Dropdown` accepted a single combined
 * `Placement` string (e.g. `'bottom-start'`). `fromPlacement` translates the
 * Floating-UI placement into the Radix `{ side, align }` pair so the public
 * `Dropdown` API (which still takes `placement`) is preserved byte-for-byte.
 *
 * Pure function — trivially unit-testable, no DI (per KISS).
 */

export type DropdownSide = 'top' | 'right' | 'bottom' | 'left';
export type DropdownAlign = 'start' | 'center' | 'end';

const PLACEMENT_MAP: Record<
  string,
  { side: DropdownSide; align: DropdownAlign }
> = {
  top: { side: 'top', align: 'center' },
  'top-start': { side: 'top', align: 'start' },
  'top-end': { side: 'top', align: 'end' },
  bottom: { side: 'bottom', align: 'center' },
  'bottom-start': { side: 'bottom', align: 'start' },
  'bottom-end': { side: 'bottom', align: 'end' },
  right: { side: 'right', align: 'center' },
  'right-start': { side: 'right', align: 'start' },
  'right-end': { side: 'right', align: 'end' },
  left: { side: 'left', align: 'center' },
  'left-start': { side: 'left', align: 'start' },
  'left-end': { side: 'left', align: 'end' },
};

export function fromPlacement(placement?: Placement): {
  side: DropdownSide;
  align: DropdownAlign;
} {
  return (
    PLACEMENT_MAP[placement ?? 'bottom-start'] ?? PLACEMENT_MAP['bottom-start']
  );
}
